export const colors = {
  blue: '#3C67F6',
  green: '#00bf79',
  white: '#FFFFFF',
  red: '#F83A53',
  grey: '#2F3137',
  lightGrey: 'white',
  black: '#1C1D21',
  orange: '#e68319',
  yellow: 'yellow',
  purple: 'purple',
};
// new orange #e68319
//old orange #D58936
// new green #00bf79
// old green #32936F


// old blue 2c67be
// old red dd1919
// old green 1d8a0c

// old grey 2E2D2D

// export const colors = {
//   blue: '#2c67be',
//   green: '#32a81f',
//   white: '#FFFFFF',
//   red: '#a81515',
//   grey: '#363636',
//   lightGrey: '#e0e0e0',
//   black: '#191919',
//   orange: 'orange',
//   yellow: 'yellow',
//   purple: 'purple',
// };


//new option 1
// export const colors = {
//   blue: '#2c67be',
//   green: '#4DA167',
//   white: '#FFFFFF',
//   red: '#D81E5B',
//   grey: '#48555B',
//   lightGrey: '#e0e0e0',
//   black: '#202431',
//   orange: '#FF9000',
//   yellow: 'yellow',
//   purple: 'purple',
// };
